import { CustomerFormModel } from './CustomerForm';

export const initialCustomerFormModel: CustomerFormModel = {
	name: '',
	timeZone: '',
};
